import { cn } from "@/utils/cn";
import { memo } from "react";

interface CircleNotchIconProps {
  className?: string;
}

export const CircleNotchIcon = memo(function CircleNotchIcon({ className }: CircleNotchIconProps) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-black", className)}
    >
      <path d="M36.25 20.0001C36.25 24.3099 34.538 28.4431 31.4905 31.4906C28.443 34.538 24.3098 36.2501 20 36.2501C15.6902 36.2501 11.557 34.538 8.50951 31.4906C5.46205 28.4431 3.75 24.3099 3.75 20.0001C3.75 13.5938 7.47031 7.75633 13.2281 5.11415C13.3773 5.04561 13.5385 5.00713 13.7026 5.0009C13.8666 4.99467 14.0303 5.02081 14.1842 5.07783C14.3382 5.13485 14.4794 5.22164 14.5998 5.33323C14.7202 5.44482 14.8174 5.57903 14.8859 5.72821C14.9545 5.87738 14.993 6.03859 14.9992 6.20264C15.0054 6.36668 14.9793 6.53035 14.9223 6.68429C14.8652 6.83823 14.7784 6.97944 14.6669 7.09984C14.5553 7.22024 14.421 7.31749 14.2719 7.38602C9.39844 9.62352 6.25 14.5735 6.25 20.0001C6.25 23.6468 7.69866 27.1442 10.2773 29.7228C12.8559 32.3014 16.3533 33.7501 20 33.7501C23.6467 33.7501 27.1441 32.3014 29.7227 29.7228C32.3013 27.1442 33.75 23.6468 33.75 20.0001C33.75 14.5735 30.6016 9.62352 25.7281 7.38602C25.4269 7.24761 25.1929 6.99519 25.0778 6.68429C24.9626 6.37339 24.9757 6.02948 25.1141 5.72821C25.2525 5.42694 25.5049 5.19299 25.8158 5.07783C26.1267 4.96267 26.4706 4.97574 26.7719 5.11415C32.5297 7.75633 36.25 13.5938 36.25 20.0001Z" />
    </svg>
  );
});
